module.exports = "<div ng-if=\"$ctrl.item && $ctrl.item.preferred_time && $ctrl.guests\">\n    <button type=\"button\" class=\"button button--wide / c-basket-add\" ng-click=\"$ctrl.addToBasket()\" ng-disabled=\"$ctrl.buttonDisabled()\">\n        Add to basket\n        <spinner ng-if=\"$ctrl.buttonDisabled()\"></spinner>\n    </button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/basket/views/basket.add.html
// module id = 833
// module chunks = 0